import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatCalendar, MatCalendarCellClassFunction, MatCalendarView } from '@angular/material/datepicker';
import moment from 'moment';

@Component({
    selector: 'app-calendar',
    templateUrl: './calender.component.html',
    styleUrls: ['./calender.component.scss'],
    standalone: false
})
export class CalendarComponent {

  @Input("selectedData") selectedData: any;
  @Input("DateConfig") DateConfig: any;
  @Input("constMax") constMax: any;
  @Output() applyFilter: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('calendar') calendar!: MatCalendar<Date>;

  headerName:any='Date Selection'
  Weekstyle: string = "month";

  minDate = new Date(2024, 0, 1); // Min selectable date
  maxDate = new Date(2025, 11, 31); // Max selectable date

  selectedStartDate: Date | any = null;
  selectedEndDate: Date | any = null;

  startAt: Date = new Date(); // Initial month for the left calendar

  isRestriction: "yes" | "no" = "yes"; // Date Restriction
  selectedType:"D"|"W"  = "D";   // selected timecycle
  constructor() {}



  DateFilter = (date: Date | null): boolean => {
    if (!date) return false;
    // Apply filter only when selectedType is "W" (Weekly)
    if (this.selectedType === "W") {
      const endDate = new Date(this.DateConfig.option.maxDate);
      return date.getDay() === endDate.getDay(); // Enable only matching weekdays
    }
    return true; // Allow all dates for other types
  };

  onViewChanged(type: "start" | "end", event: MatCalendarView): void { this.Weekstyle = event;}
  
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['selectedData']?.currentValue!=changes['selectedData']?.previousValue) {
      // Set initial calendar views
      this.startAt = new Date(this.selectedData.to_date);
      this.selectedStartDate = this.selectedData.from_date;
      this.selectedEndDate = this.selectedData.to_date;
      this.selectedType= this.DateConfig.selectedType;
      this.minDate = this.DateConfig.option.minDate;
      this.maxDate = this.selectedType=="D"?(this.constMax?this.DateConfig.option.maxDate:new Date()):this.DateConfig.option.maxDate;
      this.isRestriction = this.DateConfig.option.isRestriction;
    }
  }

     
  dateClass: MatCalendarCellClassFunction<Date> = (date: Date): string => {
    if (this.selectedType === "D")return '';
    if (!this.selectedStartDate || !this.selectedEndDate) {
      if (this.selectedType === "W") {
        const endDate = new Date(this.DateConfig.option.maxDate);
        return date.getDay() === endDate.getDay() ? 'cal_selected-weekend enabled-weekday' : '';
      }
      return '';
    }

    const time = date.getTime();
    if (time === this.selectedStartDate.getTime()) {
      return 'cal_selected-range cal_selected-start';
    }
    if (time === this.selectedEndDate.getTime()) {
      return 'cal_selected-range cal_selected-end';
    }
    if (time > this.selectedStartDate.getTime() && time < this.selectedEndDate.getTime()) {
      return 'cal_selected-range';
    }
    if (this.selectedType === "W") {
      const endDate = new Date(this.DateConfig.option.maxDate);
      return date.getDay() === endDate.getDay() ? 'cal_selected-weekend enabled-weekday' : '';
    }
    return '';
  };
  
  selectDate(date: Date|any) {
    if(this.selectedType=="D"){
      this.selectedStartDate = this.constMax? date:this.selectedData.from_date;
      this.selectedEndDate = date;
    }else if(this.selectedType=="W"){
      this.selectedStartDate = moment(date).subtract(6,'d').toDate();
      this.selectedEndDate = date;
    }
    
    this.calendar.updateTodaysDate();
  }
  
  clearDates() {
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.calendar.updateTodaysDate();
  }
  
  applyDates() {
    console.log('Applied Dates:', {
      from_date: this.selectedStartDate,
      to_date: this.selectedEndDate,
    });
    // Emit event for Apply
    this.applyFilter.emit({ from_date: this.selectedStartDate, to_date: this.selectedEndDate });
    //close method
    document.getElementById("du-page")?.click()
  }
  }